import { useQuery } from "@tanstack/react-query";
import { vaultCashKeys } from "apis/salary/query_keys_salary";
import { getVaultCashHist } from "apis/salary/vaultcash_manage_api";

import { restEmpty, simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 운영일지 시재금 현황
export const useVaultCashHist = (queryData, enabled, setEnabled) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: vaultCashKeys.hist(queryData),
    queryFn: () => getVaultCashHist(queryData),
    enabled: enabled,
    retry: false,
    cacheTime: 0,

    select: (data) => {
      const result = data.data.data;
      // null값을 빈배열로 대체
      if (restEmpty(result)) {
        return {
          ...data,
          data: {
            ...data.data,
            data: [],
          },
        };
      }

      return data;
    },
    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setEnabled(false);
    },
  });
};
